module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_SK-ac27c88a6942e2cd79002c094b8262da.svg";